export const courierReducer = (state = { cities: [] }, action) => {
  switch (action.type) {
    case "GET_LISTS_CITIES":
      return {
        ...state,
        cities: action.payload
      };
    default:
      return state;
  }
};
